// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainContainer {
  color: #fff;
}

.number {
  text-align: center;
  margin-top: 75px;
}

.building {
  font-size: 18px;
}

.asset {
  font-size: 18px;
}
.showingNumber{
  font-size: 60px;
  padding-top: 40px;
  margin-bottom: 20px;
  text-align: center;
}

.css-sghohy-MuiButtonBase-root-MuiButton-root.Mui-disabled {
  color: #666666 !important;
  background: #919191 !important;
  border: 1px solid #999999 !important;
}
.buildDetails {
 margin-top: -70px;
  padding: 25px 12px;
}


.chart .date-picker-container .react-datepicker__input-container input:not([type="range"]):not([type="color"]){
 width: 70px !important;
}
.chart {
  background-color: #282b30;
  margin-top: 28px;
  height: fit-content;
  padding: 5px;
}

.alarmsCard {
  background-color: #282b30;
  margin-top: 28px;
  padding: 10px;
  margin-left: 10px;
}
.cen {
  text-align: center;
}

@keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.blinking-circle {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  animation: blink 1s infinite;
  display: inline-block;
}

.red {
  background-color: red;
}

.orange {
  background-color: orange;
}

.yellow {
  background-color: yellow;
}

.num {
  float: right;
}

.alarm {
  font-size: 18px;
  padding: 5px 10px;
}

.notif {
  margin-left: 20px;
}

@media screen and (max-width: 960px) {
  .cont {
    height: fit-content !important;
    position: absolute;
  }

  .alarmsCard {
    margin-left: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SiteMonitor/siteMonitoringComponent.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,oCAAoC;AACtC;AACA;CACC,iBAAiB;EAChB,kBAAkB;AACpB;;;AAGA;CACC,sBAAsB;AACvB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,8BAA8B;IAC9B,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":[".mainContainer {\n  color: #fff;\n}\n\n.number {\n  text-align: center;\n  margin-top: 75px;\n}\n\n.building {\n  font-size: 18px;\n}\n\n.asset {\n  font-size: 18px;\n}\n.showingNumber{\n  font-size: 60px;\n  padding-top: 40px;\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n.css-sghohy-MuiButtonBase-root-MuiButton-root.Mui-disabled {\n  color: #666666 !important;\n  background: #919191 !important;\n  border: 1px solid #999999 !important;\n}\n.buildDetails {\n margin-top: -70px;\n  padding: 25px 12px;\n}\n\n\n.chart .date-picker-container .react-datepicker__input-container input:not([type=\"range\"]):not([type=\"color\"]){\n width: 70px !important;\n}\n.chart {\n  background-color: #282b30;\n  margin-top: 28px;\n  height: fit-content;\n  padding: 5px;\n}\n\n.alarmsCard {\n  background-color: #282b30;\n  margin-top: 28px;\n  padding: 10px;\n  margin-left: 10px;\n}\n.cen {\n  text-align: center;\n}\n\n@keyframes blink {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n.blinking-circle {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  animation: blink 1s infinite;\n  display: inline-block;\n}\n\n.red {\n  background-color: red;\n}\n\n.orange {\n  background-color: orange;\n}\n\n.yellow {\n  background-color: yellow;\n}\n\n.num {\n  float: right;\n}\n\n.alarm {\n  font-size: 18px;\n  padding: 5px 10px;\n}\n\n.notif {\n  margin-left: 20px;\n}\n\n@media screen and (max-width: 960px) {\n  .cont {\n    height: fit-content !important;\n    position: absolute;\n  }\n\n  .alarmsCard {\n    margin-left: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
